module.exports = __webpack_public_path__ + "assets/d78f6396a24ade374d6f0d9dc3a00f27.jpg";